export var RULE_TYPE = 'RULE';
export var KEYFRAME_TYPE = 'KEYFRAME';
export var FONT_TYPE = 'FONT';
export var STATIC_TYPE = 'STATIC';
export var CLEAR_TYPE = 'CLEAR';


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-utils/es/styleTypes.js
// module id = 259
// module chunks = 0